import { DbEnum } from "../generated/prisma-enums";

export type CustomModelWireProtocol = (typeof DbEnum.CUSTOM_MODEL_PROTOCOL_VALUES)[number];

/**
 * Maps custom model protocol to the ModelProvider enum value used for provider routing.
 * Single source of truth — used by both AI Task executor and Chat message processor.
 */
export const PROTOCOL_TO_PROVIDER = {
  openai: DbEnum.ModelProvider.OPEN_AI,
  anthropic: DbEnum.ModelProvider.ANTHROPIC,
  google: DbEnum.ModelProvider.GOOGLE_AI
} as const satisfies Record<CustomModelWireProtocol, DbEnum.ModelProvider>;
